const ApiUrl = {
    API_URL: "https://api.kaay.pk/api/",
    API_URL_OAuth: "https://api.kaay.pk/api/OAuth",
    API_URL_MobileVerification: "https://api.kaay.pk/api/MobileVerification"
};
export default ApiUrl